import { scrollbarWidth } from './scrollbarwidth';
var style = document.body.style;
export default (function (lock) {
    if (lock) {
        style.paddingRight = scrollbarWidth + 'px';
        style.overflow = 'hidden';
    }
    else {
        style.paddingRight = '';
        style.overflow = '';
    }
});
